<template>
    <WidgetTitle
        :styles="content.styles"
        :translation="content.translation"
        :upload="content.upload"
    >
        <div class="d-flex flex-wrap align-items-stretch mt-4">
            <PlansInfo
                home
                class="col-lg-4 col-md-6 col-sm-6 col-12 my-2"
                v-for="content in contents"
                :key="content.id"
                :color="color"
                :content="content"
                :plan="content.plan"
                @isCart="addCart"
            />
        </div>
    </WidgetTitle>
</template>

<script>
import PlansInfo from '../PlansComponents/PlansInfo'
import WidgetTitle from '../Common/WidgetTitle'

export default {
    name: 'HomePlans',
    props: {
        content: {
            type: Object,
            require: true
        },
    },
    components: {
        WidgetTitle,
        PlansInfo
    },
    data() {
        return {
            contents: this.content.contents
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
        currency() {
            return this.$store.getters.CURRENCY
        }
    },
    methods:{
        addCart(id){
            this.contents.map(content => {
                if(content.plan.id === id)
                    content.plan.isCart = true; 
                return content;
            })
        }
    }
}
</script>

<style>
</style>
